exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the User Profile module should live here.\n * Import as neede like so:\n * ...\n * import userProfileStyles from 'userProfileModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"user-profile-item\">\n * ...\n */\n\n.modules-userProfile-___userProfileModuleStyles__user-profile-item___2YZYv {\n\n}\n", ""]);

// exports
exports.locals = {
	"user-profile-item": "modules-userProfile-___userProfileModuleStyles__user-profile-item___2YZYv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/userProfile/userProfileModuleStyles.css
// module id = 1369
// module chunks = 1